function formatTestSelectorString(string) {
    return string
        .replace(/[^\w\s-]/g, '')
        .replace(/\s+/g, '-')
        .toLowerCase();
}
export function getTestSelector(field, prefix) {
    if (prefix === void 0) { prefix = ''; }
    return field ? formatTestSelectorString("".concat(prefix ? "".concat(prefix, "-") : '').concat(field)) : '';
}
